import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ACTIVATION_REQUEST_STATUSES } from '../../../../../shared/services/activationRequestStatuses';
import { ViewCreditCardRequestService } from '../../services/view-request.service';

@Component({
  selector: 'app-view-request',
  templateUrl: './view-request.component.html',
  styleUrls: ['./view-request.component.scss']
})
export class ViewRequestComponent implements OnInit, OnDestroy {
  viewRequestData: any;
  ViewRequestFlag: boolean = false;
  requestIsPending: boolean = false;
  contractData: any;
  isContract: boolean = false;

  constructor(
    private viewRequest: ViewCreditCardRequestService,
    private route: ActivatedRoute
  ) { }

  async ngOnInit() {
    this.contractData = this.route.data.subscribe(data => {
      this.isContract = data.isContract;
    });
    this.route.params.subscribe(async params => {
      this.viewRequest.setParams({ id: params.id });
      this.viewRequestData = await this.viewRequest.make();
      if(!this.viewRequestData.request){
        this.viewRequest.setParams({ id: params.id - 1 });
        this.viewRequestData = await this.viewRequest.make();
      }
      this.viewRequestData = this.viewRequestData.request;
      if (this.isContract) {
        this.requestIsPending = this.viewRequestData.status == ACTIVATION_REQUEST_STATUSES.ACCEPT;
      }
      else {
        this.requestIsPending = this.viewRequestData.status == ACTIVATION_REQUEST_STATUSES.PENDING;
      }
      this.ViewRequestFlag = true;
    })
  }

  ngOnDestroy() {
    this.contractData.unsubscribe();
  }
}

